export default __webpack_public_path__ + "static/media/Monk's Legguards of the Abyss.950cb835.jpg";